module.exports = __webpack_public_path__ + "static/img/partner1_1.49c59ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recruit/partner1_1.png
// module id = IWGh
// module chunks = 1